import { useQuery } from "@tanstack/react-query";
import { api } from "@/api";

export const inspirationFeedKeys = {
	all: ["inspirationFeed"] as const,
};

export const inspirationIdeaKeys = {
	all: ["inspirationIdeas"] as const,
};

export function useInspirationFeed() {
	return useQuery({
		queryKey: inspirationFeedKeys.all,
		queryFn: () => api.inspirationFeed.list(),
	});
}

export function useInspirationIdeas() {
	return useQuery({
		queryKey: inspirationIdeaKeys.all,
		queryFn: () => api.inspirationIdeas.list(),
	});
}
